import request from '@/utils/request';

// 查询报表数据
export function getTaskReport(params) {
  return request({
    url: '/report/view',
    method: 'get',
    params
  });
}

// 下载Excel报表
export function downloadTaskExcel(params, config = {}) {
  return request({
    url: '/report/download/excel', // 后端接口地址
    method: 'get', // 或post，与后端保持一致
    params: params, // get请求用params，post请求用data
    ...config, // 允许传入自定义配置（如responseType）
  });
}

// utils/request.js 中的axios配置（补充CORS支持）
import axios from 'axios';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000, // 下载文件超时时间设为60秒
});

// 响应拦截器（兼容Blob响应）
service.interceptors.response.use(
  (response) => {
    // 若响应类型是blob，直接返回（不解析JSON）
    if (response.config.responseType === 'blob') {
      return response;
    }
    // 普通JSON响应处理
    return response.data;
  },
  (error) => {
    // 处理Blob响应的错误（如后端返回JSON错误信息）
    if (error.config.responseType === 'blob' && error.response?.data instanceof Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result);
            reject({ ...error, response: { ...error.response, data: errorData } });
          } catch (e) {
            reject(error);
          }
        };
        reader.readAsText(error.response.data);
      });
    }
    return Promise.reject(error);
  }
);

export default service;